var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.205,
    height: 9.23,
    viewBox: "0 0 17.205 9.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2_-_Outline",
    "data-name": "Union 2 - Outline",
    d: "M12.653-.5H16.5V3.567H14.687V2.835L10.813,7.251,8.231,4.507,4.292,8.731l-5-5.288L.608,2.188,4.283,6.078,8.224,1.851l2.542,2.7L13.6,1.318h-.95Z",
    transform: "translate(0.705 0.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeUp);
export default __webpack_public_path__ + "static/media/trade-up.67d03c7924018ec515e42988a12664a7.svg";
export { ForwardRef as ReactComponent };